import { getServices } from '~/db/services';

export const useAssessmentsSyncGet = () => {
  const { $db } = useNuxtApp();
  const { assessmentsService } = getServices($db);

  const { mainContent } = useContents();

  const context = useContextStore();

  const libraryBookId = computed(() => {
    return mainContent.value != null ? mainContent.value.id : '';
  });

  const memberId = computed(() => {
    return context?.memberId != null ? context.memberId : '';
  });

  const request = ref<() => Promise<AssessmentSchema[]>>(async () => {
    try {
      return assessmentsService.findByLibraryBookIdAndMember(
        libraryBookId.value,
        memberId.value
      );
    } catch (e) {
      globalThis.$logger.info('useAssessmentsSyncGet :: error', e);
    }
  });

  const deps = computed(() => [libraryBookId.value, memberId.value]);

  const { value: assements } = useLiveQuery<AssessmentSchema[]>(
    request.value,
    deps
  );

  return { assements };
};
